const DeliveryType = {
    SELF_PICK: 'self_pick',
    SELF_SERVE: 'self_serve',
    EXPRESS: 'express',
    NONE: 'none',
};

export default DeliveryType;